import { ArslActionUpdateScaffold, ArsListingState } from "../interface";
import { buildScaffoldFromCalculatedRows } from "./buildScaffoldFromCalculatedRows";

/**
 * Updates state with new calculated listing rows from backend.
 *
 * @param state - Current ARS listing state
 * @param action - Scaffold update action
 * @returns Updated state with calculated rows replaced
 */
export const arsl_updateScaffold = <T>(
  state: ArsListingState<T>,
  action: ArslActionUpdateScaffold<T>,
): ArsListingState<T> => ({
  ...state,
  calculatedTableRows: action.calculatedTableRows,
  scaffoldModel: buildScaffoldFromCalculatedRows(
    action.calculatedTableRows,
    state.settings.editorProps,
  ),
});
